import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegacyTabPanelComponent } from './legacy-tabpanel.component';
import { LegacyTabViewComponent } from './legacy-tabview.component';

@NgModule({
  declarations: [LegacyTabPanelComponent, LegacyTabViewComponent],
  exports: [LegacyTabPanelComponent, LegacyTabViewComponent],
  imports: [CommonModule],
})
export class LegacyTabViewModule {}
